import { ts, P } from '../api';
import { Page, Section, Empty, Loading, Pill, useLoad, useTS, when } from '../ui';

// Agenda of everything with a time on it: callbacks, lead follow-ups and AI reminders.
export default function TSCalendar() {
  const session = useTS();
  const scope = session.can(P.SUPERVISE) ? 'all' : 'mine';
  const { data, loading } = useLoad(async () => {
    const [cbs, leads, rem] = await Promise.all([ts.callbacks(scope, 'open'), ts.leads({}), ts.reminders()]);
    const items = [
      ...cbs.map(c => ({ at: c.due_at, kind: 'Callback', tone: c.overdue ? 'red' : 'amber', title: `${c.customer_name || c.customer_phone} — ${c.reason}`, who: c.assigned_member_name })),
      ...leads.filter(l => l.follow_up_at).map(l => ({ at: l.follow_up_at, kind: 'Follow-up', tone: 'blue', title: l.name, who: '' })),
      ...rem.tasks.map(t => ({ at: t.due_at, kind: 'Reminder', tone: 'gray', title: t.text, who: '' })),
    ].filter(i => i.at).sort((a, b) => a.at.localeCompare(b.at));
    const days = {};
    items.forEach(i => { const d = new Date(i.at).toDateString(); (days[d] = days[d] || []).push(i); });
    return days;
  });

  if (loading && !data) return <Loading />;
  const days = Object.keys(data || {});
  return (
    <Page title="Calendar" subtitle="Callbacks, follow-ups and reminders by day.">
      {days.length === 0 ? <Section><Empty>Nothing scheduled.</Empty></Section> : days.map(d => (
        <Section key={d} title={d}>
          <ul className="divide-y divide-border text-sm">
            {data[d].map((i, n) => (
              <li key={n} className="py-1.5 flex gap-3 items-center">
                <span className="w-20 text-xs text-muted-foreground">{when(i.at).split(', ')[1] || when(i.at)}</span>
                <Pill tone={i.tone}>{i.kind}</Pill>
                <span className="flex-1">{i.title}</span>
                {i.who && <span className="text-xs text-muted-foreground">{i.who}</span>}
              </li>
            ))}
          </ul>
        </Section>
      ))}
    </Page>
  );
}
